interface InfoRowProps {
    icon: React.ReactNode;
    label: string;
    value: React.ReactNode;
    valueClassName?: string;
  }
  
  export const InfoRow: React.FC<InfoRowProps> = ({ icon, label, value, valueClassName = "font-mono" }) => (
    <div className="flex items-center justify-between p-3 bg-white rounded-lg border border-gray-200 shadow-sm">
      <span className="text-sm font-medium text-gray-600 flex items-center gap-2">
        {icon}
        {label}
      </span>
      <span className={`text-sm ${valueClassName}`}>
        {value}
      </span>
    </div>
  );

  export default InfoRow;